import { Action } from 'redux'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

const toggleCloseModal = (toggle = false): IToggleCloseModal => ({
  toggle,
  type: ReservationModalActions.ToggleCloseModal,
})

export { toggleCloseModal }

export interface IToggleCloseModal
  extends Action<ReservationModalActions.ToggleCloseModal> {
  toggle?: boolean
}
